import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axiosInstance } from "@retro-ia/shared/axios";
import { toast } from "sonner";
import type { EditActividadProgramaInput } from "@/lib/validaciones/editActividadPrograma.valicacion";

export const useUpdateActividadPrograma = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: EditActividadProgramaInput) => {
      const res = await axiosInstance.patch(
        `/actividades-programa/${data.id}`,
        data
      );
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["actividadesProgramas"] });
      queryClient.invalidateQueries({ queryKey: ["aprendices-con-actividades"] });
      toast.success("Actividad actualizada exitosamente");
    },
    onError: () => {
      toast.error("Error al actualizar la actividad");
    },
  });
};
